<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.deposit')"></NavbarSimple>
      <div class="block1">
          <div class="investWallet" @click="$router.push({ path: '/recharge', query: { type: 1 } })">
              <img src="../assets/images/investWallet.png">
              <span>{{ $t("common.investWallet") }}</span>
          </div>
          <div class="financialWallet" @click="$router.push({ path: '/recharge', query: { type: 2 } })">
              <img src="../assets/images/financialWallet.png">
              <span>{{ $t("common.financialWallet") }}</span>
          </div>
      </div>
      <div class="block2">
          <span class="text1">{{$t('depositPage.text1')}}</span>
          <span class="text2">{{$t('depositPage.text2')}}</span>
          <span class="text3">{{$t('depositPage.text3')}}</span>
          <span class="text4">{{$t('depositPage.text4')}}</span>
          <span class="text5">{{$t('depositPage.text5')}}</span>
      </div>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'deposit',
    components: {
        NavbarSimple
    }
}
</script>

<style scoped lang="less">
.block1 {
    display: flex;
    padding: 0 6.4rem;
    justify-content: space-between;
    >div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 3.733rem;
        width: 42rem;
        height: 38rem;
        border-radius: 5.333rem;
        background-color: @app-theme-color1;
        border: 0.267rem solid #d1a587;
        box-shadow: 0.667rem 1.333rem 3.888rem 0 @app-theme-color1;
        >img {
            width: 13.333rem;
        }
        >span {
            color: #fff;
            margin-top: 4rem;
        }
    }
}
.block2 {
    display: flex;
    flex-direction: column;
    padding: 0 6.4rem;
    margin-top: 8rem;
    font-size: 3.467rem;
    font-weight: bold;
    span + span {
        margin-top: 3.467rem;
    }
}
</style>